import React from 'react';
import propTypes from 'prop-types';

import { scriptTypes } from 'constants/scripts';

import FertilityZones from 'edit/FertilityZones';
import PlantingZones from 'edit/PlantingZones';

let ZonesContainer = ({
  activeZoneId,
  canChooseSeedProduct,
  fertilizerFormat,
  script,
  scriptTypeIsNitrogen,
  scriptType,
  showLiquidApplication,
  zoneRef,
  canSortZonesByProperties
}) => {

  let content;
  switch (scriptType) {
    case scriptTypes.APPLICATION:
    case scriptTypes.FERTILITY:
      content = (
        <FertilityZones
          activeZoneId={activeZoneId}
          canSortZonesByProperties={canSortZonesByProperties}
          fertilizerFormat={fertilizerFormat}
          script={script}
          scriptType={scriptType}
          scriptTypeIsNitrogen={scriptTypeIsNitrogen}
          zoneRef={zoneRef}
        />
      );
      break;
    case scriptTypes.PLANTING:
      content = (
        <PlantingZones
          activeZoneId={activeZoneId}
          canChooseSeedProduct={canChooseSeedProduct}
          canSortZonesByProperties={canSortZonesByProperties}
          script={script}
          scriptType={scriptType}
          showLiquidApplication={showLiquidApplication}
          zoneRef={zoneRef}
        />
      );
      break;
    default:
      content = null;
      break;
  }

  return (content);
};

ZonesContainer.propTypes = {
  activeZoneId: propTypes.string.isRequired,
  canChooseSeedProduct: propTypes.bool.isRequired,
  canSortZonesByProperties: propTypes.bool,
  fertilizerFormat: propTypes.string.isRequired,
  script: propTypes.object.isRequired,
  scriptTypeIsNitrogen: propTypes.bool.isRequired,
  showLiquidApplication: propTypes.bool.isRequired,
  zoneRef: propTypes.func.isRequired
};

export default ZonesContainer;
